import React from "react";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import ClassOutlinedIcon from "@mui/icons-material/ClassOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import CollectionsBookmarkOutlinedIcon from "@mui/icons-material/CollectionsBookmarkOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

export const GROUPS = [
  { key: "overview", label: "Overview" },
  { key: "setup", label: "Academic Framework" },
  { key: "content", label: "Content/Tests" },
  { key: "delivery", label: "Delivery" },
  { key: "students", label: "Students" },
];

// Icons per tab label; the tab registry itself (components, permissions) stays in Assessment.jsx.
export const TAB_ICONS = {
  Dashboard: <SpaceDashboardOutlinedIcon />,
  Reports: <AssessmentOutlinedIcon />,
  Payments: <PaymentsOutlinedIcon />,
  Exams: <SchoolOutlinedIcon />,
  Courses: <CategoryOutlinedIcon />,
  Subjects: <ClassOutlinedIcon />,
  Chapters: <AutoStoriesOutlinedIcon />,
  Synopsis: <DescriptionOutlinedIcon />,
  Topics: <LabelOutlinedIcon />,
  "Sub Topics": <AccountTreeOutlinedIcon />,
  Questions: <QuizOutlinedIcon />,
  Videos: <VideoLibraryOutlinedIcon />,
  Tests: <AssignmentOutlinedIcon />,
  "Test Series": <CollectionsBookmarkOutlinedIcon />,
  Coupons: <LocalOfferOutlinedIcon />,
  Badges: <WorkspacePremiumOutlinedIcon />,
  Students: <PeopleAltOutlinedIcon />,
  Leaderboard: <EmojiEventsOutlinedIcon />,
  "Test Types": <LayersOutlinedIcon />,
};
